// ============================================================
// === BUSINESS CONFIG — ONLY EDIT THIS SECTION ===============
// ============================================================
const BUSINESS = {
  name:             "Pristine Outdoor Services",
  tagline:          "Pristine Houses Every Time",
  logoText:         "POS",
  founded:          "2024",
  yearsInBusiness:  "1",
 
  phone:            "5169062814",
  phoneDisplay:     "(516) 906-2814",
  email:            "jamesrogan2007@gmail.com",
  address:          "East Williston, NY",
  city:             "East Williston",
  state:            "NY",
  zip:              "11596",
  county:           "Nassau County",
  hours:            "Mon–Sat 7am–6pm",
  emergency:        false,
 
  licensed:         false,
  insured:          false,
  bonded:           false,
  guarantee:        "Pristine Houses Every Time",
  studentOwned:     true,
 
  startingPrice:    "",
  freeEstimate:     true,
 
  googleReviewLink: "https://maps.app.goo.gl/55UwrkzYsEAjp3PNA",
  googleRating:     "5.0",
  googleReviewCount:"0",
 
  facebookUrl:      "",
  instagramUrl:     "",
 
  serviceAreas: [
    "East Williston",
    "Mineola",
    "Albertson",
    "Williston Park",
    "Roslyn Heights",
    "Garden City",
  ],
 
  services: [
    {
      name: "House Soft Washing",
      emoji: "🏠",
      problem: "Green algae, black streaks, and years of grime are making your home look run-down.",
      solution: "Low-pressure soft wash that kills mold and algae at the root — safe on all siding types.",
      outcome: "Your home looks freshly painted without the cost. Neighbors will notice.",
    },
    {
      name: "Driveway & Walkway Cleaning",
      emoji: "🚗",
      problem: "Oil stains, algae, and built-up grime are ruining your curb appeal.",
      solution: "High-pressure hot water blasts away years of buildup in a single pass.",
      outcome: "A bright, clean driveway that looks brand new. Instant curb appeal boost.",
    },
    {
      name: "Deck & Patio Restoration",
      emoji: "🌿",
      problem: "Your deck is gray, slippery, and starting to look like it belongs to a different house.",
      solution: "Careful, targeted cleaning that lifts mildew and restores the natural wood color.",
      outcome: "A deck you're proud to host on — ready to seal, stain, or simply enjoy.",
    },
    {
      name: "Window Cleaning",
      emoji: "🪟",
      problem: "Dirty, streaky windows are blocking natural light and making your home look neglected.",
      solution: "Interior and exterior hand washing with professional solution and squeegee technique.",
      outcome: "Crystal-clear, streak-free windows that flood your home with natural light.",
    },
    {
      name: "Fence & Surface Washing",
      emoji: "🌲",
      problem: "A dirty fence or mildew-covered surfaces drag down the whole property's appearance.",
      solution: "Full pressure washing of fences, retaining walls, and exterior surfaces.",
      outcome: "A clean, refreshed property that looks sharp from every angle.",
    },
    {
      name: "Gutter Cleaning",
      emoji: "💧",
      problem: "Clogged gutters are overflowing and quietly damaging your fascia and foundation.",
      solution: "Full gutter flush and debris removal — often bundled with a wash visit.",
      outcome: "No more water damage, overflow, or eroded landscaping. Done in one visit.",
    },
  ],
 
  seo: {
    metaTitle:       "Pristine Outdoor Services | Pressure Washing & Window Cleaning in East Williston, NY",
    metaDescription: "Student-owned pressure washing and window cleaning serving East Williston, Mineola, Albertson & all of Nassau County. Free estimates. Call (516) 906-2814.",
    keywords:        "pressure washing East Williston, window cleaning Mineola, soft wash Albertson, power washing Williston Park, house washing Nassau County, pressure washing near me",
    ogImage:         "https://placehold.co/1200x630/0a1628/ffffff?text=Pristine+Outdoor+Services",
    canonicalUrl:    "https://pristineoutdoorservices.com",
    schemaType:      "HomeAndConstructionBusiness",
    priceRange:      "$$",
  },
};
// ============================================================
 
import React, { useState, useEffect, useRef } from "react";
 
// ─── NAVBAR ────────────────────────────────────────────────
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
 
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
 
  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
 
  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
      <div className="nav-inner">
        <div className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <span className="logo-mark">P</span>
          <span className="logo-text">Pristine<span>Outdoor</span></span>
        </div>
 
        <div className={`nav-links${menuOpen ? " open" : ""}`}>
          {["services","how-it-works","reviews","service-areas","contact"].map((id) => (
            <button key={id} className="nav-link" onClick={() => scrollTo(id)}>
              {id.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
            </button>
          ))}
          <a href={`tel:+1${BUSINESS.phone}`} className="nav-cta">
            📞 {BUSINESS.phoneDisplay}
          </a>
        </div>
 
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span className={menuOpen ? "open" : ""}></span>
          <span className={menuOpen ? "open" : ""}></span>
          <span className={menuOpen ? "open" : ""}></span>
        </button>
      </div>
    </nav>
  );
}
 
// ─── HERO ──────────────────────────────────────────────────
function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <img
          src="https://placehold.co/1920x1080/0a1628/1e3a5f?text=Pristine+Outdoor+Services"
          alt={`Pristine Outdoor Services pressure washing in ${BUSINESS.city}, ${BUSINESS.state}`}
        />
        <div className="hero-overlay"></div>
      </div>
 
      <div className="hero-content container">
        <div className="hero-badge-row">
          <span className="hero-pill">⭐ Student-Owned Business</span>
          <span className="hero-pill">📍 Nassau County, NY</span>
        </div>
 
        <h1 className="hero-h1">
          Expert Pressure Washing<br />
          <span className="hero-accent">&amp; Window Cleaning</span><br />
          in {BUSINESS.city}, NY
        </h1>
 
        <p className="hero-sub">
          Dirt, grime, and algae are aging your home fast. One visit from us — and it's gone. Guaranteed.
        </p>
 
        <div className="hero-trust-bar">
          <span>✓ Free Estimates</span>
          <span>✓ {BUSINESS.guarantee}</span>
          <span>✓ Student-Owned &amp; Operated</span>
          <span>✓ Nassau County Local</span>
        </div>
 
        <div className="hero-ctas">
          <a href={`tel:+1${BUSINESS.phone}`} className="btn btn-primary btn-lg">
            📞 Call Now — It's Free
          </a>
          <a
            href={`sms:+1${BUSINESS.phone}?body=Hi%2C%20I%27d%20like%20to%20get%20a%20free%20quote%20for%20pressure%20washing%20%2F%20window%20cleaning%20at%20my%20property.`}
            className="btn btn-sms btn-lg"
          >
            💬 Text Us
          </a>
          <button
            className="btn btn-outline btn-lg"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
          >
            Get a Free Quote →
          </button>
        </div>
      </div>
 
      <div className="hero-scroll-hint">
        <span>↓</span>
      </div>
    </section>
  );
}
 
// ─── SOCIAL PROOF STRIP ────────────────────────────────────
function ProofStrip() {
  return (
    <div className="proof-strip">
      <div className="proof-inner container">
        <div className="proof-item">
          <span className="proof-icon">⭐</span>
          <span>5-Star Rated on Google</span>
        </div>
        <div className="proof-divider"></div>
        <div className="proof-item">
          <span className="proof-icon">🎓</span>
          <span>Proud Student-Owned Business</span>
        </div>
        <div className="proof-divider"></div>
        <div className="proof-item">
          <span className="proof-icon">📍</span>
          <span>Serving All of Nassau County</span>
        </div>
        <div className="proof-divider"></div>
        <div className="proof-item">
          <span className="proof-icon">💯</span>
          <span>{BUSINESS.guarantee}</span>
        </div>
      </div>
    </div>
  );
}
 
// ─── SERVICES ──────────────────────────────────────────────
function Services() {
  return (
    <section className="section services-section" id="services">
      <div className="container">
        <div className="section-header fade-in">
          <span className="section-label">What We Do</span>
          <h2>Services That Make Your Property Shine</h2>
          <p className="section-sub">
            From grimy driveways to streaky windows — we handle it all, and we don't leave until it looks pristine.
          </p>
        </div>
 
        <div className="services-grid">
          {BUSINESS.services.map((service, i) => (
            <div className="service-card fade-in" key={i}>
              <div className="service-emoji">{service.emoji}</div>
              <h3 className="service-name">{service.name}</h3>
              <div className="service-detail">
                <div className="service-tag problem-tag">Problem</div>
                <p>{service.problem}</p>
              </div>
              <div className="service-detail">
                <div className="service-tag solution-tag">Solution</div>
                <p>{service.solution}</p>
              </div>
              <div className="service-detail">
                <div className="service-tag outcome-tag">Outcome</div>
                <p>{service.outcome}</p>
              </div>
              <a href={`tel:+1${BUSINESS.phone}`} className="service-cta">
                Get a Quote →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
 
// ─── HOW IT WORKS ──────────────────────────────────────────
function HowItWorks() {
  const steps = [
    { num: "01", title: "Call or Request a Quote", desc: "Reach out by phone or fill out our form. We respond the same day — usually within a couple hours." },
    { num: "02", title: "Free On-Site Assessment", desc: "We come out, look at your property, and give you a clear price. No pressure, no obligation." },
    { num: "03", title: "We Get to Work", desc: "We show up on time with professional equipment and get your property looking spotless." },
    { num: "04", title: "You Love It — Guaranteed", desc: "If it's not pristine, we make it right. Every single time, no exceptions." },
  ];
 
  return (
    <section className="section how-section" id="how-it-works">
      <div className="container">
        <div className="section-header fade-in">
          <span className="section-label">The Process</span>
          <h2>Simple. Fast. Spotless.</h2>
          <p className="section-sub">Getting a clean property shouldn't be complicated. Here's how it works.</p>
        </div>
        <div className="steps-grid">
          {steps.map((step, i) => (
            <div className="step-card fade-in" key={i}>
              <div className="step-num">{step.num}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-desc">{step.desc}</p>
            </div>
          ))}
        </div>
        <div className="how-cta fade-in">
          <a href={`tel:+1${BUSINESS.phone}`} className="btn btn-primary btn-lg">
            📞 Call Now — We'll Answer
          </a>
        </div>
      </div>
    </section>
  );
}
 
// BeforeAfter removed — no photos yet
 
// ─── REVIEWS ───────────────────────────────────────────────
function Reviews() {
  return (
    <section className="section reviews-section" id="reviews">
      <div className="container">
        <div className="section-header fade-in">
          <span className="section-label">Google Reviews</span>
          <h2>What Nassau County Says About Us</h2>
          <p className="section-sub">We're brand new — which means you could be our first review. We'd love to earn it.</p>
        </div>
 
        <div className="reviews-placeholder fade-in">
          <div className="review-coming-card">
            <div className="stars">★★★★★</div>
            <p className="review-placeholder-text">
              "Reviews coming soon — we just launched! Be the first in your neighborhood to experience the Pristine difference and leave us a review."
            </p>
            <div className="reviewer-info">
              <span className="reviewer-name">Your Name Here</span>
              <span className="reviewer-city">{BUSINESS.city}, NY</span>
            </div>
          </div>
 
          <div className="review-cta-block">
            <p>Had us out? We'd love to hear about it.</p>
            <a
              href={BUSINESS.googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline"
            >
              Leave Us a Google Review ↗
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
 
// ─── SERVICE AREAS ─────────────────────────────────────────
function ServiceAreas() {
  return (
    <section className="section areas-section" id="service-areas">
      <div className="container">
        <div className="section-header fade-in">
          <span className="section-label">Where We Work</span>
          <h2>Proudly Serving {BUSINESS.city} &amp; All of Nassau County</h2>
          <p className="section-sub">
            {BUSINESS.name} provides pressure washing and window cleaning throughout {BUSINESS.county}.
            Whether you're in {BUSINESS.serviceAreas[0]}, {BUSINESS.serviceAreas[1]}, {BUSINESS.serviceAreas[2]}, or anywhere nearby — we're your local crew.
          </p>
        </div>
        <div className="areas-grid fade-in">
          {BUSINESS.serviceAreas.map((city, i) => (
            <span className="area-badge" key={i}>{city}</span>
          ))}
        </div>
        <p className="areas-footnote fade-in">Not on the list? Call us — we likely serve your area too.</p>
      </div>
 
      {/* Hidden SEO block */}
      <div
        aria-hidden="true"
        style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0,0,0,0)" }}
      >
        {`${BUSINESS.name} proudly serves ${BUSINESS.serviceAreas.join(", ")} and surrounding areas in ${BUSINESS.county}, ${BUSINESS.state}. Pressure washing, window cleaning, soft washing, driveway cleaning, deck restoration.`}
      </div>
    </section>
  );
}
 
// ─── ABOUT ─────────────────────────────────────────────────
function About() {
  const textMsg = encodeURIComponent("Hi! Can I get a free quote please?");
  return (
    <section className="section about-section" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-image fade-in">
            <img
              src="https://placehold.co/500x600/0a1628/4fc3f7?text=Pristine+Outdoor%0AServices"
              alt={`${BUSINESS.name} — ${BUSINESS.city}, ${BUSINESS.state}`}
            />
            <div className="about-img-badge">
              <span>🎓</span>
              <span>Student Owned</span>
            </div>
          </div>
 
          <div className="about-content fade-in">
            <span className="section-label">Our Story</span>
            <h2>Local. Student-Run. Spotless Results.</h2>
            <p>
              Pristine Outdoor Services was started right here on Long Island by a local student who saw neighbors spending thousands on basic exterior cleaning and knew there had to be a better option.
            </p>
            <p>
              What started as a way to earn money between semesters turned into something we genuinely care about. We show up personally to every job, use professional-grade equipment, and don't leave until the property looks exactly as advertised — pristine.
            </p>
            <p>
              Being student-owned means lower overhead and better prices than the big operations. It also means our reputation is on the line with every single driveway, window, and siding we touch. That's a guarantee the big companies can't make.
            </p>
 
            <div className="about-badges">
              <div className="about-badge">🎓 Student-Owned &amp; Operated</div>
              <div className="about-badge">📍 Nassau County Local</div>
              <div className="about-badge">💯 {BUSINESS.guarantee}</div>
              <div className="about-badge">🔧 Pro-Grade Equipment</div>
            </div>
 
            <div className="about-cta-row">
              <a href={`tel:+1${BUSINESS.phone}`} className="btn btn-primary">
                📞 Call Now
              </a>
              <a href={`sms:+1${BUSINESS.phone}?body=${textMsg}`} className="btn btn-sms">
                💬 Text Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
 
// ─── CONTACT ───────────────────────────────────────────────
function Contact() {
  const [formData, setFormData] = useState({ name: "", phone: "", email: "", service: "", message: "" });
  const [submitStatus, setSubmitStatus] = useState("idle");
 
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("loading");
 
    const payload = {
      name:      formData.name,
      phone:     formData.phone,
      email:     formData.email,
      service:   formData.service,
      message:   formData.message,
      _subject:  `New Quote Request — ${BUSINESS.name}`,
      _captcha:  "false",
      _template: "table",
    };
 
    try {
      const res = await fetch(`https://formsubmit.co/ajax/${BUSINESS.email}`, {
        method:  "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body:    JSON.stringify(payload),
      });
      if (res.ok) {
        setSubmitStatus("success");
        setFormData({ name: "", phone: "", email: "", service: "", message: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch {
      setSubmitStatus("error");
    }
  };
 
  const serviceOptions = [
    "House Soft Washing", "Driveway & Walkway Cleaning", "Deck & Patio Restoration",
    "Window Cleaning", "Fence & Surface Washing", "Gutter Cleaning", "Multiple Services", "Other",
  ];
 
  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <div className="section-header fade-in">
          <span className="section-label">Get Started</span>
          <h2>Get Your Free Estimate Today</h2>
          <p className="section-sub">Fill out the form, call, or tap the button below to text us directly. If we miss your call — text us and we'll get back to you fast.</p>
        </div>
 
        <div className="contact-grid">
          <div className="contact-info fade-in">
            <h3>Get In Touch</h3>
            <div className="contact-detail">
              <span className="contact-icon">📞</span>
              <div>
                <strong>Phone</strong>
                <a href={`tel:+1${BUSINESS.phone}`}>{BUSINESS.phoneDisplay}</a>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-icon">✉️</span>
              <div>
                <strong>Email</strong>
                <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-icon">🕐</span>
              <div>
                <strong>Hours</strong>
                <span>{BUSINESS.hours}</span>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-icon">📍</span>
              <div>
                <strong>Service Area</strong>
                <span>{BUSINESS.county}, NY</span>
              </div>
            </div>
            <div className="contact-guarantee">
              <span>💯</span>
              <p>{BUSINESS.guarantee} — or we make it right.</p>
            </div>
 
            <div className="contact-text-cta">
              <p className="text-cta-note">Prefer to text? Tap below — we'll reply fast.</p>
              <a
                href={`sms:+1${BUSINESS.phone}?body=Hi%2C%20I%27d%20like%20to%20get%20a%20free%20quote%20for%20pressure%20washing%20%2F%20window%20cleaning%20at%20my%20property.`}
                className="btn btn-sms btn-full"
              >
                💬 Text Us for a Free Quote
              </a>
              <p className="text-cta-sub">If we don't call back within an hour — text us and we'll respond right away.</p>
            </div>
          </div>
 
          <div className="contact-form-wrapper fade-in">
            {submitStatus === "success" ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Quote Request Received!</h3>
                <p>We'll reach out within a few hours. Or call right now:</p>
                <a href={`tel:+1${BUSINESS.phone}`} className="btn btn-primary">
                  📞 {BUSINESS.phoneDisplay}
                </a>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input id="name" name="name" type="text" required placeholder="John Smith"
                      value={formData.name} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input id="phone" name="phone" type="tel" required placeholder="(516) 555-0192"
                      value={formData.phone} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input id="email" name="email" type="email" placeholder="john@email.com"
                    value={formData.email} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="service">Service Needed *</label>
                  <select id="service" name="service" required value={formData.service} onChange={handleChange}>
                    <option value="">Select a service...</option>
                    {serviceOptions.map((s, i) => <option key={i} value={s}>{s}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Tell Us About Your Property</label>
                  <textarea id="message" name="message" rows={4}
                    placeholder="Describe the areas you need cleaned, approximate size, anything specific..."
                    value={formData.message} onChange={handleChange} />
                </div>
                <button type="submit" className="btn btn-primary btn-full"
                  disabled={submitStatus === "loading"}>
                  {submitStatus === "loading" ? "Sending..." : "Get My Free Estimate →"}
                </button>
                {submitStatus === "error" && (
                  <p className="form-error">
                    Something went wrong. Call us directly:{" "}
                    <a href={`tel:+1${BUSINESS.phone}`}>{BUSINESS.phoneDisplay}</a>
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
 
// ─── FOOTER ────────────────────────────────────────────────
function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-mark">P</span>
              <span className="logo-text">Pristine<span>Outdoor</span></span>
            </div>
            <p className="footer-tagline">{BUSINESS.tagline}</p>
            <a href={`tel:+1${BUSINESS.phone}`} className="footer-phone">
              📞 {BUSINESS.phoneDisplay}
            </a>
            <a href={`mailto:${BUSINESS.email}`} className="footer-email">
              ✉️ {BUSINESS.email}
            </a>
            <p className="footer-hours">🕐 {BUSINESS.hours}</p>
            <p className="footer-student">🎓 Proud Student-Owned Business</p>
          </div>
 
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {BUSINESS.services.map((s, i) => <li key={i}>{s.name}</li>)}
            </ul>
          </div>
 
          <div className="footer-col">
            <h4>Service Areas</h4>
            <ul>
              {BUSINESS.serviceAreas.map((city, i) => <li key={i}>{city}</li>)}
            </ul>
          </div>
 
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              {["services","how-it-works","reviews","service-areas","about","contact"].map((id) => (
                <li key={id}>
                  <button className="footer-link"
                    onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}>
                    {id.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
 
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All Rights Reserved. — {BUSINESS.county}, NY</p>
          <a href={BUSINESS.googleReviewLink} target="_blank" rel="noopener noreferrer" className="footer-review-link">
            Leave a Google Review ↗
          </a>
        </div>
      </div>
    </footer>
  );
}
 
// ─── MOBILE CTA BAR ────────────────────────────────────────
function MobileCTABar() {
  return (
    <div className="mobile-cta-bar">
      <a href={`tel:+1${BUSINESS.phone}`} className="mobile-call-btn">
        📞 Call Now — Free Estimate
      </a>
    </div>
  );
}
 
// ─── APP ───────────────────────────────────────────────────
export default function App() {
  useEffect(() => {
    document.title = BUSINESS.seo.metaTitle;
 
    const setMeta = (nameOrProp, content, isProp = false) => {
      const attr = isProp ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${nameOrProp}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, nameOrProp); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
 
    setMeta("description",    BUSINESS.seo.metaDescription);
    setMeta("keywords",       BUSINESS.seo.keywords);
    setMeta("robots",         "index, follow");
    setMeta("author",         BUSINESS.name);
    setMeta("og:type",        "website", true);
    setMeta("og:title",       BUSINESS.seo.metaTitle, true);
    setMeta("og:description", BUSINESS.seo.metaDescription, true);
    setMeta("og:image",       BUSINESS.seo.ogImage, true);
    setMeta("og:url",         BUSINESS.seo.canonicalUrl, true);
    setMeta("og:site_name",   BUSINESS.name, true);
    setMeta("twitter:card",   "summary_large_image");
    setMeta("twitter:title",  BUSINESS.seo.metaTitle);
    setMeta("twitter:description", BUSINESS.seo.metaDescription);
    setMeta("twitter:image",  BUSINESS.seo.ogImage);
 
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", BUSINESS.seo.canonicalUrl);
 
    const schema = {
      "@context": "https://schema.org",
      "@type":    BUSINESS.seo.schemaType,
      name:       BUSINESS.name,
      url:        BUSINESS.seo.canonicalUrl,
      telephone:  `+1${BUSINESS.phone}`,
      email:      BUSINESS.email,
      image:      BUSINESS.seo.ogImage,
      address: {
        "@type": "PostalAddress",
        addressLocality: BUSINESS.city,
        addressRegion:   BUSINESS.state,
        postalCode:      BUSINESS.zip,
        addressCountry:  "US",
      },
      priceRange:   BUSINESS.seo.priceRange,
      openingHours: BUSINESS.hours,
      areaServed:   BUSINESS.serviceAreas.map(city => ({ "@type": "City", name: city })),
    };
 
    let schemaTag = document.getElementById("local-business-schema");
    if (!schemaTag) { schemaTag = document.createElement("script"); schemaTag.id = "local-business-schema"; schemaTag.type = "application/ld+json"; document.head.appendChild(schemaTag); }
    schemaTag.textContent = JSON.stringify(schema);
 
    // Intersection Observer for fade-in animations
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll(".fade-in").forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
 
  return (
    <div className="app">
      <Navbar />
      <Hero />
      <ProofStrip />
      <Services />
      <HowItWorks />
      <Reviews />
      <ServiceAreas />
      <About />
      <Contact />
      <Footer />
      <MobileCTABar />
    </div>
  );
}
